<template>
  <ValidationObserver v-slot="{ invalid }" slim>
  <!-- <Page
    :primaryAction="{
      label: 'Save',
      onAction: () => {
        this.$emit('update', {
          nextPage,
          definition: JSON.parse(JSON.stringify(this.definition))
        })
      }
    }"
  > -->
    <Layout class="DetailsFilters">
      <picker id="Emoji-Picker" ref="Emoji-Picker" set="emojione" :title="$t('Pick an Emoji')" @select="selectEmoji" />

      <LayoutSection size="half">
        <Card :title="$t('NotificationsApp.Notification Details')">
          <CardSection>
            <FormLayout>
              <template v-if="notification.type === 'template'">
                <validation-provider :name="$t('Product / Category')">
                  <Select
                    :label="$t('Select Product / Category')"
                    :value="definition.productType"
                    @change="val => onInputChanged('productType', val)"
                    :options="productTypeList"
                    :help-text="$t('NotificationsApp.triggeredAbandonedHelp')"
                  />
                </validation-provider>
                <div v-if="definition.productType" class="info info-above" v-html="triggeredNotificationInfo"></div>
              </template>

              <validation-provider :name="$t('Heading')" immediate rules="required" v-slot="{ errors }">
                <TextField
                  :value="definition.titleSmall"
                  @input="val => onInputChanged('titleSmall', val)"
                  :label="$t('Heading')"
                  :placeholder="$t('NotificationsApp.Notification Heading')"
                  ref="titleSmall"
                  :disabled="noEditing"
                  :error="errors[0]"
                />
                <Icon icon="far fa-smile" class="Emoji-Pick" @click="showEmojiPicker('titleSmall', $event)" />
              </validation-provider>

              <validation-provider v-if="definition.extraDetails" :name="$t('Long Heading')" immediate rules="required" v-slot="{ errors }">
                <TextField
                  :value="definition.title"
                  @input="val => onInputChanged('title', val)"
                  :label="$t('Long Heading')"
                  name="title"
                  ref="title"
                  :placeholder="$t('NotificationsApp.Notification Heading')"
                  :disabled="noEditing"
                  :help-text="$t('NotificationsApp.longHeadingHelp')"
                  :error="errors[0]"
                />
                <Icon icon="far fa-smile" class="Emoji-Pick" @click="showEmojiPicker('title', $event)" />
              </validation-provider>

              <validation-provider :name="$t('Message')" immediate rules="required" v-slot="{ errors }">
                <TextField
                  :value="definition.bodySmall"
                  @input="val => onInputChanged('bodySmall', val)"
                  :label="$t('Message')"
                  name="bodySmall"
                  ref="bodySmall"
                  :placeholder="$t('NotificationsApp.messagePlaceholder')"
                  :disabled="noEditing"
                  :error="errors[0]"
                />
                <Icon icon="far fa-smile" class="Emoji-Pick" @click="showEmojiPicker('bodySmall', $event)" />
              </validation-provider>

              <validation-provider :name="$t('Long Message')" immediate :rules="{ required: definition.extraDetails }" v-slot="{ errors }">
                <TextField v-if="definition.extraDetails"
                  :label="$t('Long Message')"
                  :value="definition.body"
                  @input="val => onInputChanged('body', val)"
                  multiline
                  name="body"
                  ref="body"
                  :placeholder="$t('NotificationsApp.messagePlaceholder')"
                  :disabled="noEditing"
                  :help-text="$t('NotificationsApp.longHeadingHelp')"
                  :error="errors[0]"
                />
                <Icon icon="far fa-smile" class="Emoji-Pick" @click="showEmojiPicker('body', $event)" />
              </validation-provider>

              <ImageInput
                :label="$t('Icon')"
                :required="true"
                v-model="definition.icon"
              />

              <div v-if="notification.type === 'template'" class="info">{{$t('NotificationsApp.replacedIconMessage')}}</div>
              
              <ImageInput
                :label="$t('Image')"
                :required="true"
                v-model="definition.image"
              />

              <div v-if="notification.type !== 'template'" class="info">{{$t('NotificationsApp.imageMessage')}} <a href="https://fanplayr.gitbooks.io/web-push-notifications/content/image-sizing.html" target="_blank">{{$t('docs')}}</a>.</div>

              <validation-provider :name="$t('Default Action URL')" immediate :rules="isProductOrCategory ? 'required|urlOrCustom' : 'required|url'" v-slot="{ errors }">
                <TextField
                  :label="$t('Default Action URL')"
                  :value="definition.actionDefaultUrl"
                  @input="val => onInputChanged('actionDefaultUrl', val)"
                  @blur="checkActionUrls"
                  placeholder="https://mystore.com/product/xyz/"
                  :disabled="noEditing"
                  :help-text="defaultActionInfo"
                  :error="errors[0]"
                />
              </validation-provider>

              <template v-if="notification.type === 'template'" class="form-group">
                <TextField
                  :label="$t('Extra URL Parameters')"
                  :value="definition.extraUrlParameters"
                  @input="val => onInputChanged('extraUrlParameters', val)"
                  placeholder="utm_source=web&amp;utm_campaign=abandoned%20cart"
                  :disabled="noEditing"
                  :help-text="notification.type === 'template' ? 'If you add URL encoded variables they will be added to URLs smartly. They must be entered including URL encodings.' : ''"
                />
              </template>

              <Checkbox
                :label="$t('Action Required')"
                :value="definition.actionRequired"
                @change="val => onInputChanged('actionRequired', val)"
                :disabled="noEditing"
                :help-text="$t('NotificationsApp.actionRequiredHelp')"
              />

              <Button v-if="!hasAction1 && canEdit" type="primary" @click="addAction1">{{$t('Add Action')}}</Button>

              <template v-if="hasAction1">
                <Card :title="$t('Action')" subdued>
                  <CardSection>
                    <FormLayout>
                      <!-- v-validate="'required'" -->
                      <validation-provider :name="$t('Text')" immediate rules="required" v-slot="{ errors }">
                        <TextField
                          :label="$t('Text')"
                          :value="definition.action1TextSmall"
                          @input="val => onInputChanged('action1TextSmall', val)"
                          :disabled="noEditing"
                          :error="errors[0]"
                          name="action1TextSmall"
                          ref="action1TextSmall"
                        />
                        <Icon icon="far fa-smile" class="Emoji-Pick" @click="showEmojiPicker('action1TextSmall', $event)" />
                      </validation-provider>

                      <validation-provider :name="$t('Text - Long')" immediate rules="required" v-slot="{ errors }">
                        <TextField
                          :label="$t('Text - Long')"
                          :value="definition.action1Text"
                          @input="val => onInputChanged('action1Text', val)"
                          name="action1Text"
                          ref="action1Text"
                          :disabled="noEditing"
                          :error="errors[0]"
                        />
                        <Icon icon="far fa-smile" class="Emoji-Pick" @click="showEmojiPicker('action1Text', $event)" />
                      </validation-provider>

                      <validation-provider :name="$t('URL')" immediate :rules="isProductOrCategory ? 'required|urlOrCustom' : 'required|url'" v-slot="{ errors }">
                        <TextField
                          :label="$t('URL')"
                          :value="definition.action1Url"
                          @input="val => onInputChanged('action1Url', val)"
                          name="action1Url"
                          @blur="checkActionUrls"
                          :disabled="noEditing"
                          :error="errors[0]"
                        />
                      </validation-provider>

                      <Button v-if="canEdit" @click="removeAction1">{{$t('Remove Action')}}</Button>
                    </FormLayout>
                  </CardSection>
                </Card>
                <Button v-if="!hasAction2 && canEdit" type="primary" @click="addAction2">{{$t('Add Another Action')}}</Button>
              </template>

              <template v-if="hasAction2">
                <Card :title="$t('Action')" subdued>
                  <CardSection>
                    <FormLayout>
                      
                      <validation-provider :name="$t('Text')" immediate rules="required" v-slot="{ errors }">
                        <TextField
                          :label="$t('Text')"
                          :value="definition.action2TextSmall"
                          @input="val => onInputChanged('action2TextSmall', val)"
                          :disabled="noEditing"
                          :error="errors[0]"
                        />
                        <Icon icon="far fa-smile" class="Emoji-Pick" @click="showEmojiPicker('action2TextSmall', $event)" />
                      </validation-provider>
                      
                      <validation-provider :name="$t('Text - Long')" immediate rules="required" v-slot="{ errors }">
                        <TextField v-if="definition.extraDetails"
                          :label="$t('Text - Long')"
                          :value="definition.action2Text"
                          @input="val => onInputChanged('action2Text', val)"
                          :disabled="noEditing"
                          :error="errors[0]"
                        />
                        <Icon icon="far fa-smile" class="Emoji-Pick" @click="showEmojiPicker('action2Text', $event)" />
                      </validation-provider>

                      <validation-provider :name="$t('URL')" immediate :rules="isProductOrCategory ? 'required|urlOrCustom' : 'required|url'" v-slot="{ errors }">
                        <TextField
                          :title="$t('URL')"
                          :value="definition.action2Url"
                          @input="val => onInputChanged('action2Url', val)"
                          @blur="checkActionUrls"
                          :disabled="noEditing"
                          :error="errors[0]"
                        />
                      </validation-provider>

                      <Button v-if="canEdit" @click="removeAction2">{{$t('Remove Action')}}</Button>
                    </FormLayout>
                  </CardSection>
                </Card>
              </template>

            </FormLayout>
          </CardSection>
        </Card>
      </LayoutSection>

      <LayoutSection size="half">
        <FormLayout class="BrowserPreviews">

          <Card v-if="hasMacChrome || hasMacFirefox" title="MacOS">
            <CardSection>
              <div class="BrowserPreviews-heading">
                <Checkbox
                  :label="$t('NotificationsApp.Dark Mode')"
                  v-model="isMacOsDark"
                />
              </div>

              <ul>
                <li v-if="hasMacChrome">
                  <div class="Browser-Name">
                    <div class="Icon-Browser chrome"></div>
                    {{$t('Chrome')}}
                  </div>
                  <p class="Browser-Instructions">{{$t('NotificationsApp.Roll over to access the menu')}}</p>
                  <preview-mac-chrome :base="base" :dark="isMacOsDark" class="Preview"></preview-mac-chrome>
                </li>

                <li v-if="hasMacFirefox">
                  <div class="Browser-Name">
                    <div class="Icon-Browser firefox"></div>
                    {{$t('FireFox')}}
                  </div>
                  <preview-mac-firefox :base="base" :dark="isMacOsDark" class="Preview"></preview-mac-firefox>
                </li>
              </ul>

            </CardSection>
          </Card>

          <Card v-if="hasAndroidChrome || hasAndroidEdge || hasAndroidFirefox" title="Android">
            <CardSection>
              <div class="BrowserPreviews-heading">
                <Checkbox
                  :label="$t('NotificationsApp.Version 7 and below')"
                  v-model="isAndroid7AndBelow"
                />
              </div>

            <ul>
              <li v-if="hasAndroidChrome">
                <div class="Browser-Name">
                  <div class="Icon-Browser chrome"></div>
                  <div class="Icon-Browser edge multiple"></div>
                  <div class="Icon-Browser opera multiple"></div>
                  {{$t('NotificationsApp.Chrome, Edge, and Opera')}}
                </div>
                <p class="Browser-Instructions">{{$t('NotificationsApp.Roll over to see the extended state')}}</p>
                <preview-android-chrome :base="base" :isAndroid7AndBelow="isAndroid7AndBelow" class="Preview"></preview-android-chrome>
              </li>
              <li v-if="hasAndroidEdge || hasAndroidFirefox">
                <div class="Browser-Name">
                  <div class="Icon-Browser firefox"></div>
                  {{$t('Firefox')}}
                </div>
                <preview-android-general :base="base" class="Preview"></preview-android-general>
              </li>
            </ul>
            </CardSection>
          </Card>

          <Card v-if="hasWindowsChrome || hasWindowsEdge || hasWindowsFirefox" title="Windows">
            <CardSection>
              <div class="BrowserPreviews-heading">
                <Checkbox
                  :label="$t('NotificationsApp.< Oct 2018')"
                  v-model="isBelowWindowsOctober2018"
                />
              </div>

              <ul>
                <li v-if="hasWindowsChrome">
                  <div class="Browser-Name">
                    <div class="Icon-Browser chrome"></div>
                    {{$t('Chrome')}}
                  </div>
                  <preview-windows-chrome :base="base" v-if="isBelowWindowsOctober2018" class="Preview"></preview-windows-chrome>
                  <preview-windows-2018-chrome :base="base" v-if="!isBelowWindowsOctober2018" class="Preview"></preview-windows-2018-chrome>
                </li>
                <li v-if="hasWindowsEdge">
                  <div class="Browser-Name">
                    <div class="Icon-Browser edge"></div>
                    {{$t('Edge')}}
                  </div>
                  <preview-windows-edge :base="base" v-if="isBelowWindowsOctober2018" class="Preview"></preview-windows-edge>
                  <preview-windows-2018-edge :base="base" v-if="!isBelowWindowsOctober2018" class="Preview"></preview-windows-2018-edge>
                </li>
                <li v-if="hasWindowsFirefox">
                  <div class="Browser-Name">
                    <div class="Icon-Browser firefox"></div>
                    {{$t('Firefox')}}
                  </div>
                  <preview-windows-firefox :base="base" class="Preview"></preview-windows-firefox>
                </li>
              </ul>
              
            </CardSection>
          </Card>

        </FormLayout>
      </LayoutSection>

      <LayoutSection v-if="!theUser.isDemoAccount" size="full">
        <Card>
          <CardSection v-if="notification.type !== 'template' && notification.status === 'draft'">
            <Stack>
              <Button :disabled="invalid" @click="changePage('filters')">{{$t('Save + Back')}}</Button>
              <Button @click="changePage('filters', false)">{{$t('Back')}}</Button>
              <Button type="primary" :disabled="invalid" @click="changePage('scheduling')">{{$t('Save + Next')}}</Button>
            </Stack>
          </CardSection>

          <CardSection v-if="notification.type === 'template'">
            <Stack v-if="notification.status === 'draft'">
              <Button type="primary" :disabled="invalid" @click="activateTemplate">{{$t('Activate Now')}}</Button>
              <Button @click="changePage('saveTemplate')">{{$t('Save and Continue Later')}}</Button>
            </Stack>
            <Stack v-else>
              <Button type="primary" @click="changePage('saveTemplate')">{{$t('Save')}}</Button>
            </Stack>
          </CardSection>

        </Card>
      </LayoutSection>

    </Layout>
  <!-- </Page> -->
  </ValidationObserver>
</template>

<script>

// import EmojiPicker from 'vue-emoji-picker'
import _ from 'lodash'
import PreviewMacChrome from '../components/PreviewMacChrome.vue'
import PreviewMacFirefox from '../components/PreviewMacFirefox.vue'
import PreviewAndroidGeneral from '../components/PreviewAndroidGeneral.vue'
import PreviewAndroidChrome from '../components/PreviewAndroidChrome.vue'
import PreviewWindowsChrome from '../components/PreviewWindowsChrome.vue'
import PreviewWindows2018Chrome from '../components/PreviewWindows2018Chrome.vue'
import PreviewWindowsFirefox from '../components/PreviewWindowsFirefox.vue'
import PreviewWindowsEdge from '../components/PreviewWindowsEdge.vue'
import PreviewWindows2018Edge from '../components/PreviewWindows2018Edge.vue'
import ImageInput from '../../../components/ui/ImageInput.vue'
import NotificationUtils from '../classes/NotificationUtils.class'
import { Picker } from 'emoji-mart-vue'
import { extend as ValidateExtend } from 'vee-validate/dist/vee-validate.full'

export default {
  name: 'NotificationsEditDetails',
  inject: ['store'],
  props: {
    notification: Object
  },
  data() {
    return {
      // default for preview props
      isMacOsDark: false,
      isBelowWindowsOctober2018: false,
      isAndroid7AndBelow: false,
      //
      triggeredNotificationInfo: '',
      productTypeList: [],
      //
      defaultActionInfo: '',
      //
      language: 'en',
      hasAction1: false,
      hasAction2: false,
      domainToDisplay: '',
      base: NotificationUtils.getDefaultDefinition(),
      definition: NotificationUtils.getDefaultDefinition(),
      emojiPopper: null,
      emojiEl: null,
      emojiJustShown: false,
      emojiLastSelectedEl: null,
      emojiLastSelectedElName: null,
      emojiLastSelectedElPosition: null,
      input: '',
      search: '',
      defCopy: null,
    }
  },
  mounted() {

    ValidateExtend('url', (value) => {
      if (value && !value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/)) {
        return this.$t('validation.validUrl', { field: '{_field_}' })
      }
      return true
    })

    ValidateExtend('urlOrCustom', (value) => {
      if (value && !value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)|{{\s*url\s*}}?$/)) {
        return this.$t('validation.urlOrCustom', { field: '{_field_}', url: '"{{url}}"' })
      }
      return true
    })

    this.defaultActionInfo = this.$t('NotificationsApp.When a user clicks anywhere on your notification, other than on the close, settings or defined action buttons, they will be taken here')

    if (this.notification.definition) {
      this.definition = {
        ...NotificationUtils.getDefaultDefinition(),
        ...this.notification.definition
      }
      this.definition.extraUrlParameters = this.definition.extraUrlParameters || ''
    }
    if (this.notification.definition && this.notification.definition.action1TextSmall) {
      this.hasAction1 = true
    }
    if (this.notification.definition && this.notification.definition.action2TextSmall) {
      this.hasAction2 = true
    }
        
    // 2019-12-03: Specific domains no longer applicable because we have templates
    // that apply to multiple domains.
    this.domainToDisplay = 'domain.com'

    this.definition.extraDetails = true

    this.productTypeList = [
      { value: '', label: this.$t('None') },
      { value: 'firstProduct', label: this.$t('NotificationsApp.First Product Viewed / in Cart') },
      { value: 'lastProduct', label: this.$t('NotificationsApp.Last Product Viewed / in Cart') },
      { value: 'highestPriceProduct', label: this.$t('NotificationsApp.Highest Priced Product Viewed / in Cart') },
      { value: 'lowestPriceProduct', label: this.$t('NotificationsApp.Lowest Priced Product Viewed / in Cart') },
      { value: 'firstCategory', label: this.$t('NotificationsApp.First Category Viewed') },
      { value: 'lastCategory', label: this.$t('NotificationsApp.Last Category Viewed') },
    ]
    if (!this.definition.productType) {
      this.definition.productType = this.productTypeList[0].value
    }

    this.$watch('definition.productType', () => this.updateInfoBasedOnProductType())
    this.updateInfoBasedOnProductType()

    this.updateBase()

    this.$watch('definition.icon', () => {
      this.updateBase()
    })
    this.$watch('definition.image', () => {
      this.updateBase()
    })

    this.defCopy = _.cloneDeep(this.definition)

    this.emojiEl = this.$refs['Emoji-Picker'].$el
    document.body.addEventListener('click', this.bodyClick)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.bodyClick)
  },
  computed: {
    isProductOrCategory() {
      return !!(this.definition
        && this.definition.productType
        && (this.definition.productType.indexOf('Product') > -1 || this.definition.productType.indexOf('Category') > -1)
      )
    },
    canEdit() {
      return this.notification.status === 'draft' || this.notification.type !== 'manual'
    },
    hasMacChrome() {
      return this.notification.segments.osBrowserCombinations.macos && this.notification.segments.osBrowserCombinations.macos.includes('chrome')
    },
    hasMacFirefox() {
      return this.notification.segments.osBrowserCombinations.macos && this.notification.segments.osBrowserCombinations.macos.includes('firefox')
    },
    hasAndroidGeneral() {
      return this.notification.segments.osBrowserCombinations.android && this.notification.segments.osBrowserCombinations.android.includes('general')
    },
    hasAndroidFirefox() {
      return this.notification.segments.osBrowserCombinations.android && this.notification.segments.osBrowserCombinations.android.includes('firefox')
    },
    hasAndroidChrome() {
      return this.notification.segments.osBrowserCombinations.android && this.notification.segments.osBrowserCombinations.android.includes('chrome')
    },
    hasAndroidEdge() {
      return this.notification.segments.osBrowserCombinations.android && this.notification.segments.osBrowserCombinations.android.includes('edge')
    },
    hasWindowsChrome() {
      return this.notification.segments.osBrowserCombinations.windows && this.notification.segments.osBrowserCombinations.windows.includes('chrome')
    },
    hasWindowsFirefox() {
      return this.notification.segments.osBrowserCombinations.windows && this.notification.segments.osBrowserCombinations.windows.includes('firefox')
    },
    hasWindowsEdge() {
      return this.notification.segments.osBrowserCombinations.windows && this.notification.segments.osBrowserCombinations.windows.includes('edge')
    },
    noEditing() {
      return this.notification.type === 'manual' && this.notification.status !== 'draft'
    }
  },
  methods: {
    onInputChanged(key, newValue) {
      this.definition[key] = newValue
      this.updateBase()
    },
    checkActionUrls() {
      // fix URLs?
      const fixUrl = (u) => {
        let uu = u
        if (!uu || uu.indexOf('.') === -1) {
          return uu
        }
        if (uu.toLowerCase().substr(0, 4) !== 'http') {
          uu = `https://${uu}`
        }
        if (uu.substring(8, uu.length).indexOf('/') === -1) {
          uu = `${uu}/`
        }
        return uu
      }
      this.definition.actionDefaultUrl = fixUrl(this.definition.actionDefaultUrl)
      this.definition.action1Url = fixUrl(this.definition.action1Url)
      this.definition.action2Url = fixUrl(this.definition.action2Url)
    },
    updateInfoBasedOnProductType() {
      if (this.definition && this.definition.productType && this.definition.productType.indexOf('Product') > -1) {
        this.triggeredNotificationInfo = this.$t('NotificationsApp.Please use {{ name }} in input text to display the product name')
        this.defaultActionInfo = this.$t('NotificationsApp.Please use {{ url }} to direct users to the specific product page')
      } else if (this.definition && this.definition.productType && this.definition.productType.indexOf('Category') > -1) {
        this.triggeredNotificationInfo = this.$t('NotificationsApp.Please use {{ name }} in input text to display the category name')
        this.defaultActionInfo = this.$t('NotificationsApp.Please use {{ url }} to direct users to the specific category page')
      }
    },
    selectEmoji(emoji) {
      if (this.emojiLastSelectedEl) {
        const el = this.emojiLastSelectedEl
        const definitionName = this.emojiLastSelectedElName
        // have to do it this way because otherwise v-model doesn't seem to work correctly ... ?
        this.definition[definitionName] = el.value.substr(0, this.emojiLastSelectedElPosition) + emoji.native + el.value.substr(this.emojiLastSelectedElPosition)
        this.emojiLastSelectedElPosition += emoji.native.length
        this.updateBase()
      }
    },
    showEmojiPicker(refName) {
      if (!this.emojiJustShown) {
        this.emojiLastSelectedEl = this.$refs[refName].$el.querySelector('input')
        if (!this.emojiLastSelectedEl) {
          this.emojiLastSelectedEl = this.$refs[refName].$el.querySelector('textarea')
        }
        this.emojiLastSelectedElName = refName
        this.emojiEl.style.display = 'block'
        this.emojiLastSelectedElPosition = this.emojiLastSelectedEl.selectionStart
        // eslint-disable-next-line
        this.emojiPopper = new Popper(this.emojiLastSelectedEl, this.emojiEl, {
          placement: 'right',
          positionFixed: true,
          offset: '0, 15'
        })
        this.emojiJustShown = true
        // this.$nextTick(() => {
        //   this.emojiJustShown = false
        // })
        setTimeout(() => {
          this.emojiJustShown = false
        }, 100)
      }
    },
    bodyClick(e) {
      if (this.emojiJustShown) {
        return
      }
      if (!this.emojiPopper) {
        return
      }
      const target = e.target
      if (target === this.emojiEl || this.emojiEl.contains(target)) {
        return
      }
      this.emojiEl.style.display = 'none'
      this.emojiPopper.destroy()
      this.emojiPopper = null
    },
    isValidUrlParameters(value) {
      return /[^=]+=.+/.test(value)
    },
    async changePage(nextPage, forceSave = true) {
      this.checkActionUrls()
      if (forceSave) {
        this.$emit('update', {
          nextPage,
          definition: JSON.parse(JSON.stringify(this.definition))
        })
      } else {
        if (!_.isEqual(this.defCopy, this.definition)) {
          const res = await this.$ui.confirm({
            title: this.$t('Unsaved Changes'),
            content: this.$t('messaging.loseChangesMessage'),
            primaryActionLabel: this.$t('Discard changes'),
            primaryActionType: 'destructive',
            secondaryActionLabel: this.$t('Continue editing')
          })
          if (!res) return;
        }
        this.$emit('goToPage', nextPage)
      }
    },
    escape(str) {
      return (str || '').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    changeExtraDetails() {
      if (this.definition.extraDetails) {
        this.definition.title = this.definition.titleSmall
        this.definition.body = this.definition.bodySmall
      } else {
        this.definition.title = ''
        this.definition.body = ''
      }
      this.updateBase()
    },
    updateBase() {
      const isTriggered = this.notification.type === 'template'
      const extraDetails = this.definition.extraDetails !== null ? this.definition.extraDetails : false
      this.base.extraDetails = extraDetails
      this.base.titleSmall = this.escape(this.definition.titleSmall) || `<em style="color: #a00;">${this.$t('NotificationsApp.Notification Heading')}</em>`
      this.base.bodySmall = this.escape(this.definition.bodySmall) || `<em style="color: #a00;">${this.$t('NotificationsApp.This is the message for your Notification')}</em>`
      this.base.icon = this.definition.icon || ''
      this.base.image = this.definition.image || ''
      this.base.action1TextSmall = this.escape(this.definition.action1TextSmall) || ''
      this.base.action2TextSmall = this.escape(this.definition.action2TextSmall) || ''
      this.base.action1Text = extraDetails ? this.escape(this.definition.action1Text) : this.base.action1TextSmall
      this.base.action2Text = extraDetails ? this.escape(this.definition.action2Text) : this.base.action2TextSmall
      this.base.actionDefaultUrl = this.definition.actionDefaultUrl || ''
      this.base.action1Url = this.definition.action1Url || ''
      this.base.action2Url = this.definition.action2Url || ''
      this.base.actionRequired = this.definition.actionRequired || false
      this.base.domain = this.domainToDisplay || ''

      this.base.title = this.definition.title ? this.escape(this.definition.title) : this.base.titleSmall
      this.base.body = this.definition.body ? this.escape(this.definition.body).replace(/\n/g, '<br />') : this.base.bodySmall

      this.base.extraUrlParameters = this.definition.extraUrlParameters

      if (isTriggered) {
        this.base.title = this.base.title.replace(/{{\s*name\s*}}/gi, `<em style="color: #030;">${this.$t('NotificationsApp.SAMPLE PRODUCT NAME')}</em>`)
        this.base.body = this.base.body.replace(/{{\s*name\s*}}/gi, `<em style="color: #030;">${this.$t('NotificationsApp.SAMPLE PRODUCT NAME')}</em>`)
        this.base.titleSmall = this.base.titleSmall.replace(/{{\s*name\s*}}/gi, `<em style="color: #030;">${this.$t('NotificationsApp.SAMPLE PRODUCT NAME')}</em>`)
        this.base.bodySmall = this.base.bodySmall.replace(/{{\s*name\s*}}/gi, `<em style="color: #030;">${this.$t('NotificationsApp.SAMPLE PRODUCT NAME')}</em>`)
        this.base.action1Text = this.base.action1Text.replace(/{{\s*name\s*}}/gi, `<em style="color: #030;">${this.$t('NotificationsApp.SAMPLE PRODUCT NAME')}</em>`)
        this.base.action1TextSmall = this.base.action1TextSmall.replace(/{{\s*name\s*}}/gi, `<em style="color: #030;">${this.$t('NotificationsApp.SAMPLE PRODUCT NAME')}</em>`)
        this.base.action2Text = this.base.action2Text.replace(/{{\s*name\s*}}/gi, `<em style="color: #030;">${this.$t('NotificationsApp.SAMPLE PRODUCT NAME')}</em>`)
        this.base.action2TextSmall = this.base.action2TextSmall.replace(/{{\s*name\s*}}/gi, `<em style="color: #030;">${this.$t('NotificationsApp.SAMPLE PRODUCT NAME')}</em>`)
      }

      // console.log(JSON.stringify(this.base))
    },
    addAction1() {
      this.hasAction1 = true
    },
    addAction2() {
      this.hasAction2 = true
    },
    removeAction1() {
      if (this.hasAction2) {
        this.definition.action1Text = this.definition.action2Text
        this.definition.action1TextSmall = this.definition.action2TextSmall
        this.definition.action1Url = this.definition.action2Url
        this.definition.action2Text = ''
        this.definition.action2TextSmall = ''
        this.definition.action2Url = ''
        this.hasAction2 = false
      } else {
        this.hasAction1 = false
        this.definition.action1Text = ''
        this.definition.action1TextSmall = ''
        this.definition.action1Url = ''
      }
      this.updateBase()
    },
    removeAction2() {
      this.hasAction2 = false
      this.definition.action2Text = ''
      this.definition.action2TextSmall = ''
      this.definition.action2Url = ''
      this.updateBase()
    },
    activateTemplate() {
      const self = this
      this.$ui.confirm({
        title: this.$t('Activate Template?'),
        onConfirm() {
          self.changePage('activateTemplate')
        }
      })
    },
  },
  directives: {
    emoji: {
      inserted(el) {
        el.insertAdjacentHTML('beforebegin', '<div class="EmojiPickerActivator" click="InvokeEmoji(this)"><svg height="24" viewBox="0 0 24 24" width="24" fill="#b1c6d0" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/></svg></div>')
      }
    }
  },
  components: {
    PreviewMacChrome,
    PreviewMacFirefox,
    PreviewAndroidGeneral,
    PreviewAndroidChrome,
    PreviewWindowsChrome,
    PreviewWindows2018Chrome,
    PreviewWindowsFirefox,
    PreviewWindowsEdge,
    PreviewWindows2018Edge,
    Picker,
    ImageInput
  }
};
</script>

<style>
  div[class^="FormLayout_FormLayoutItem_"] {
    position: relative;
  }
</style>

<style lang="less" scoped>

  .BrowserPreviews-heading {
    float: right;
    margin-top: -35px;
  }

  .Browser-Name {
    margin-bottom: 15px;
    padding-bottom: 10px;
    padding-top: 9px;
    font-weight: bold;
  }

  .Preview {
    margin-bottom: 1rem;
  }

  .Browser-Instructions {
    margin-bottom: 25px;
    font-style: italic;
  }

  .info {
    background: #eee;
    padding: 10px;
    font-size: 90%;
    margin-bottom: 20px;
    margin-top: -15px;
  }
  .info-above {
    margin-bottom: 15px;
    margin-top: 20px;
  }
  .image-selector {
    display: block;
  }
  .Preview {
    margin-left: auto;
    margin-right: auto;
  }
  .Action1 {
    margin-bottom: 25px;
  }
  #Emoji-Picker {
    display: none;
    z-index: 1;
  }
  .Emoji-Pick {
    position: absolute;
    right: 10px;
    top: 32px;
    font-size: 20px;
    color: #ccc;
    cursor: pointer;
    &:hover {
      color: #666;
    }
  }
  .long-message {
    font-size: 80%;
    color: #999;
  }
</style>
<style>
  .emoji-mart-scroll {
    height: 270px;
  }
</style>
